import {ActionCreator, createAction} from '@packages/utilities/create-action';
import {DesignerWorkflow} from '../types';
import {
  DESIGNER_WORKFLOW_MODE_CHANGE_REQUESTED,
  DESIGNER_WORKFLOW_MODE_CHANGE_COMPLETED,
  DESIGNER_WORKFLOW_MODE_CHANGE_REJECTED,
} from '@packages/systems/designer/actions';
import type {DesignerActionFromCreator} from '@packages/systems/designer/flux';

type DesignerWorkflowModeChangeRequestedPayload = {
  /**
   * The `DesignerWorkflow` we are changing to
   */
  workflow: DesignerWorkflow;
  /**
   * The source of the change request in the UI for analytics purposes
   */
  source: string;
};

export const designerWorkflowModeChangeRequested: ActionCreator<
  typeof DESIGNER_WORKFLOW_MODE_CHANGE_REQUESTED,
  DesignerWorkflowModeChangeRequestedPayload
> = createAction(DESIGNER_WORKFLOW_MODE_CHANGE_REQUESTED);

export type DesignerWorkflowModeChangeRequestedAction =
  DesignerActionFromCreator<typeof designerWorkflowModeChangeRequested>;

type DesignerWorkflowModeChangeCompletedPayload =
  DesignerWorkflowModeChangeRequestedPayload & {
    /**
     * The `DesignerWorkflow` we are transitioning away from
     */
    fromWorkflow: DesignerWorkflow;
  };

export const designerWorkflowModeChangeCompleted: ActionCreator<
  typeof DESIGNER_WORKFLOW_MODE_CHANGE_COMPLETED,
  DesignerWorkflowModeChangeCompletedPayload
> = createAction(DESIGNER_WORKFLOW_MODE_CHANGE_COMPLETED);

export const designerWorkflowModeChangeRejected: ActionCreator<
  typeof DESIGNER_WORKFLOW_MODE_CHANGE_REJECTED,
  void
> = createAction(DESIGNER_WORKFLOW_MODE_CHANGE_REJECTED);

export type DesignerWorkflowModeChangeCompletedAction =
  DesignerActionFromCreator<typeof designerWorkflowModeChangeCompleted>;

export type DesignerWorkflowModeChangeRejectedAction =
  DesignerActionFromCreator<typeof designerWorkflowModeChangeRejected>;
